import template from 'text!./templates/ho-coverages-edit.html';

export default [function () {
    return {
        template: template,
        'restrict': 'E',
        'scope': {
            model: '=',
            onBaseCovChange: '&',
            onAdditionalCovChange: '&',
            next: '&',
            loading: '='
        },
        'controller': ['$scope', 'CoveragesUtil', function ($scope, CoveragesUtil) {

            /**
             * Next button is clicked
             *
             * @param {Object} form the coverage form to validate
             */
            $scope.onNext = function (form) {
                if (CoveragesUtil.validateForm(form)) {
                    // Call next method on parent
                    $scope.next();
                }
            };
        }]

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOCoveragesEdit.js
// module id = 1456
// module chunks = 0